import { useEffect, useState } from "react";
import api from "../lib/api";

// Tenant-configurable built-in ticket fields (/field-configs).
// Fields default to enabled when no config row exists.
export default function useFieldConfigs() {
  const [cfg, setCfg] = useState({});
  useEffect(() => {
    api.get("/field-configs")
      .then((r) => setCfg(Object.fromEntries(r.data.map((c) => [c.key, c]))))
      .catch(() => {});
  }, []);
  const fieldOn = (k) => (cfg[k] ? cfg[k].enabled : true);
  const fieldReq = (k) => !!(cfg[k] && cfg[k].enabled && cfg[k].required);
  // Sub-types are mandatory only while Request Type itself is required.
  const subtypeReq = () => fieldReq("request_type") && !!cfg.request_type.subtypes_required;
  return { fieldOn, fieldReq, subtypeReq };
}
